import React from "react";
import style from "./style.module.css";
type Props = {
  src: any;
  alt: string;
  className?: string;
  loading?: boolean;
};

export default function ImageComponent(props: Props) {
  return (
    <>
      {props.loading ? (
        <div className={style.loader} />
      ) : (
        <img
          src={props.src as string}
          alt={props.alt}
          className={`${props.className}`}
        />
      )}
    </>
  );
}
